import {closeDropdown, DropdownItem} from 'platform/components';
import {Icon, Show} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {SaleVehicleAlbumPhotoGuideItem} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {PhotoGuideActions} from '../hooks/usePhotoGuideActions';
import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';
import {PhotoTypeSubmenu} from './PhotoTypeSubmenu';

interface PhotoGuideContextMenuItemsProps extends TestIdProps {
  image: UnifiedAlbumImage;
  /** The layout item the photo fills, when it is in a slot or placed as an Extra Photo. */
  photoGuideItem: SaleVehicleAlbumPhotoGuideItem | undefined;
  dropdownId: string;
  actions: Pick<PhotoGuideActions, 'assignPhotoType' | 'unassignPhoto'>;
}

/** The Photo Guide entries of a photo's context menu: assign a Photo Type, leave the layout. */
export function PhotoGuideContextMenuItems(props: PhotoGuideContextMenuItemsProps) {
  return (
    <>
      <PhotoTypeSubmenu
        photoType={props.image.photoType}
        onSelect={(photoType) => {
          closeDropdown(props.dropdownId);
          props.actions.assignPhotoType(props.image.id, photoType);
        }}
        data-testid={props['data-testid']}
      />
      <Show when={props.photoGuideItem}>
        {(item) => (
          <DropdownItem
            label={
              isNotNil(item.photoType)
                ? i18n.t('entity.photoGuide.actions.removeFromSlot')
                : i18n.t('entity.photoGuide.actions.moveToBacklog')
            }
            prefix={<Icon value="content/remove_circle_outline" />}
            onClick={() => props.actions.unassignPhoto(props.image.id)}
            data-testid={suffixTestId('unassign', props)}
          />
        )}
      </Show>
    </>
  );
}
